// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"94b2a945","171":"9b9e3371","388":"3c5847f5","488":"3bbb9338"}[chunkId] + ".chunk.js";
};